/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
import React from "react";
import {
  InfoCircleOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from "@ant-design/icons";

const IndeksKarakterHorizontalCard = ({ title, data, icon = null }) => {
  return (
    <div
      style={{
        backgroundColor: "#1B6FBA",
        display: "flex",
        flexFlow: "row",
        justifyContent: "space-between",
        padding: 8,
        color: "#fff",
      }}
    >
      <div className="text-default" style={{ color: "#fff" }}>
        {title}
      </div>
      <div className="text-default" style={{ color: "#fff" }}>
        <span>{data}</span>
        {icon !== null ? (
          icon ? (
            <ArrowUpOutlined
              style={{
                fontWeight: 700,
                color: "#2CF6E5",
              }}
            />
          ) : (
            <ArrowDownOutlined
              style={{
                fontWeight: 700,
                color: "#FF859C",
              }}
            />
          )
        ) : null}
        &nbsp;
        <InfoCircleOutlined />
      </div>
    </div>
  );
};

export default IndeksKarakterHorizontalCard;
